import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useState } from "react";
import { AlertTriangle, Eye, Smartphone, Monitor } from "lucide-react";
import { PhoneFrame } from "./PhonePreview";

export const ReminderPreviewDialog = ({ preview, onClose }) => {
  const [phone, setPhone] = useState(true);
  return (
  <Dialog open={!!preview} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="sm:max-w-2xl max-h-[92vh] overflow-y-auto" data-testid="reminder-preview-dialog">
      <DialogHeader>
        <DialogTitle className="font-heading text-sky-900 text-xl flex items-center gap-2">
          <Eye className="w-5 h-5" /> Vista previa del recordatorio
        </DialogTitle>
        <DialogDescription>Así le llega al pasajero, con sus datos reales.</DialogDescription>
      </DialogHeader>
      {preview?.problems?.length > 0 && (
        <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700 flex gap-2" data-testid="reminder-preview-problems">
          <AlertTriangle className="w-4 h-4 shrink-0 mt-0.5" />
          <div>
            <p className="font-semibold">No se va a enviar hasta que lo corrijas:</p>
            <ul className="list-disc ml-4">
              {preview.problems.map((p) => <li key={p}>{p}</li>)}
            </ul>
          </div>
        </div>
      )}
      <div className="flex gap-1" data-testid="reminder-preview-mode">
        <button type="button" onClick={() => setPhone(true)} className={`px-3 py-1 rounded-full text-xs flex items-center gap-1 ${phone ? "bg-sky-900 text-white" : "bg-sky-50 text-sky-700"}`} data-testid="reminder-preview-phone"><Smartphone className="w-3.5 h-3.5" /> Celular</button>
        <button type="button" onClick={() => setPhone(false)} className={`px-3 py-1 rounded-full text-xs flex items-center gap-1 ${!phone ? "bg-sky-900 text-white" : "bg-sky-50 text-sky-700"}`} data-testid="reminder-preview-desktop"><Monitor className="w-3.5 h-3.5" /> Computadora</button>
      </div>
      <div className="text-sm space-y-1 text-sky-900">
        <p><span className="text-sky-600/80">Para:</span> <span data-testid="reminder-preview-recipients">{preview?.recipients?.join(", ")}</span></p>
        <p><span className="text-sky-600/80">Asunto:</span> <strong data-testid="reminder-preview-subject">{preview?.subject}</strong></p>
      </div>
      {phone ? (
        <div className="flex justify-center"><PhoneFrame html={preview?.html} whatsapp={preview?.message} /></div>
      ) : (
      <>
      <iframe
        title="Vista previa del email"
        srcDoc={preview?.html || ""}
        sandbox=""
        className="w-full h-[420px] rounded-lg border border-sky-100 bg-sky-50"
        data-testid="reminder-preview-iframe"
      />
      <div>
        <p className="text-xs uppercase tracking-wider font-semibold text-emerald-700 mb-1">WhatsApp</p>
        <p className="whitespace-pre-wrap [overflow-wrap:anywhere] text-sm bg-emerald-50/60 border border-emerald-100 rounded-lg p-3 text-sky-900" data-testid="reminder-preview-message">
          {preview?.message}
        </p>
      </div>
      </>
      )}
    </DialogContent>
  </Dialog>
  );
};
